import { OpenTalkApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from '../event/keys';

function useCreate() {
  const queryClient = useQueryClient();
  return useAuthMutation(OpenTalkApi.post, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).details(),
      });
    },
  });
}

export default useCreate;
